import DebugSection from './components/DebugSection'
import DebugModal from './DebugModal'
import RefractionOverrideView from './views/RefractionOverrideView'

export default function RefractionDebugModal() {
  return (
    <DebugModal debugKey="refraction" label="Refraction">
      <DebugSection title="Refraction Override">
        <RefractionOverrideView />
      </DebugSection>
    </DebugModal>
  )
}
